import { Link } from "react-router-dom";
import SectionHeading from "@/components/base/SectionHeading";
import { collections } from "@/mocks/events";

export default function CollectionsSection() {
  return (
    <section className="mx-auto w-full max-w-[1200px] px-4 py-12 md:px-6 md:py-16">
      <SectionHeading
        eyebrow="Featured Collections"
        title="推荐赛事专题合集"
        description="按热门度与赛事类型精心整理，帮你快速锁定值得熬夜的那几场。"
      />
      <div className="grid grid-cols-1 gap-5 sm:grid-cols-2">
        {collections.map((col) => (
          <Link
            key={col.id}
            to={`/live/${col.eventIds[0]}`}
            className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-100 transition-colors hover:border-primary-500/50 sm:flex-row cursor-pointer"
          >
            <div className="relative h-44 w-full overflow-hidden sm:h-auto sm:w-44 md:w-52">
              <img
                src={col.image}
                alt={`${col.title}专题`}
                title={`${col.title} - jrs直播`}
                className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
            </div>
            <div className="flex flex-1 flex-col p-5">
              <div className="flex items-center justify-between gap-3">
                <span className="rounded-full bg-accent-500/15 px-2.5 py-1 text-[11px] font-semibold text-accent-400">
                  {col.tag}
                </span>
                <span className="text-xs text-foreground-500">
                  共 {col.eventCount} 场
                </span>
              </div>
              <h3 className="mt-3 font-heading text-lg font-bold text-foreground-950">
                {col.title}
              </h3>
              <p className="mt-0.5 text-xs font-medium uppercase tracking-[0.12em] text-primary-400">
                {col.subtitle}
              </p>
              <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">
                {col.description}
              </p>
              <span className="mt-4 inline-flex items-center gap-1.5 text-sm font-semibold text-foreground-800 transition-colors group-hover:text-primary-400">
                查看专题
                <i className="ri-arrow-right-line" />
              </span>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}